import { Offer } from "@assets/types"

export const isCashbackProduct = (promotion: Offer | undefined) => [
  'cashback_product_money',
  'cashback_product_percent',
].includes(promotion?.mechanic ?? '')